import {
  FormControl,
  InputLabel,
  TextField,
  TextFieldProps,
} from "@mui/material";

export const Input = ({ label, id, sx, ...props }: TextFieldProps) => {
  return (
    <FormControl variant="standard" fullWidth>
      {label && (
        <InputLabel
          shrink
          htmlFor={id}
          sx={{ color: "#fff", fontWeight: 700, fontSize: "16px" }}
        >
          {label}
        </InputLabel>
      )}
      <TextField
        sx={{
          "& .MuiOutlinedInput-root": {
            marginTop: label ? 3 : 0,
          },

          "& input::-webkit-calendar-picker-indicator": {
            filter: "invert(100%) brightness(100%)",
          },
          ...sx,
        }}
        id={id}
        autoComplete={"off"}
        {...props}
      />
    </FormControl>
  );
};
